import { action, makeObservable, observable } from "mobx";
import { IBaseReportFilterAddon, ReportFilterAddonsKeys } from "../ReportFilterAddon";
import { ReportFilterModel } from "../ReportFilter_model";
import { Button, ButtonTypes } from "../../../components/ui/Button";
import { SHOW_BUSINESS_AREA_SELECTION_MODAL } from "../../modalZ/common/BusinessAreaTreeView/BusinessAreaTreeViewModal";
import { observer } from "mobx-react-lite";
import I18n from "../../localization/I18n";

export class BusinessAreaReportFilterAddon implements IBaseReportFilterAddon {
  key: string = ReportFilterAddonsKeys.BusinessArea;
  @observable selectedIds: number[] = [];
  reportFilterModel: ReportFilterModel;

  constructor(reportFilterModel: ReportFilterModel, currentFilter: any) {
    makeObservable(this);
    this.setSelectedIds(currentFilter || []);
    this.reportFilterModel = reportFilterModel;
  }

  clearSelectedIds = () => {
    this.setSelectedIds([]);
  };

  render = () => {
    return <ButtonArea key={this.key} model={this} />;
  };

  displayModal = () => {
    SHOW_BUSINESS_AREA_SELECTION_MODAL(this.getQueryJSON, this.selectedIds);
  };

  getQueryJSON = (businessAreaIds: number[]) => {
    this.setSelectedIds(businessAreaIds);
    this.reportFilterModel.generateQueryJson();
    return {
      [this.key]: this.selectedIds
    };
  };

  getSelectedIds = () => {
    return this.selectedIds;
  };

  @action
  setSelectedIds = (selectedIds: number[]) => (this.selectedIds = selectedIds);
}

const ButtonArea: React.FC<{ model: BusinessAreaReportFilterAddon }> = observer(({ model }) => {
  return (
    <Button key={model.key} className="px-2" type={ButtonTypes.LINK} onClick={model.displayModal}>
      {I18n.t("entities.businessAreas") + " "}
      {model.selectedIds.length > 0 ? (model.selectedIds.length < 10 ? `(${model.selectedIds.length})` : "9+") : ""}
    </Button>
  );
});
